import UpdatePickOrder from '../../../../components/@documents/pick_orders/UpdatePickOrder';

import {routeTypes} from "../../../../hooks/useSystemRoutes";

export default function PickOrderUpdatePage() {

    return (
        <UpdatePickOrder
            routeType={routeTypes.admin}
        />
    )
}